// extracted by mini-css-extract-plugin
module.exports = {"header":"MenuHeader_header__3QxZc","text":"MenuHeader_text__3U-zO"};